module.exports = __webpack_public_path__ + "static/img/bg_persona2.4367cb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_persona2.png
// module id = dGtu
// module chunks = 1